import type { ReactNode } from "react";
import React from "react";
import Styles from "./DropdownList.module.scss";

type Props = {
	children: ReactNode;
};

function PDropdownList({ children }: Props) {
	return <div className={Styles.DropdownList}>{children}</div>;
}

export const DropdownList = React.memo(PDropdownList);
